import type {RouteBuildContext} from './types';

import {createContext, useContext} from 'react';

const RouteBuildReactContext = createContext<RouteBuildContext | null>(null);

type RouteBuildProviderProps = {
  value: RouteBuildContext;
  children: React.ReactNode;
};

export function RouteBuildProvider({value, children}: RouteBuildProviderProps) {
  return (
    <RouteBuildReactContext.Provider value={value}>{children}</RouteBuildReactContext.Provider>
  );
}

export function useRouteBuildContext(): RouteBuildContext {
  const ctx = useContext(RouteBuildReactContext);

  if (!ctx) {
    throw new Error('useRouteBuildContext must be used within RouteBuildProvider');
  }

  return ctx;
}
